import ar from './ar/';
import de from './de/';
import en_US from './en-US/';
import es from './es/';
import fr from './fr/';
import ja_JP from './ja-JP/';
import nl from './nl/';
import pt_BR from './pt-BR/';
import ru from './ru/';
import test_LNG from './test-LNG/';
import tr_TR from './tr-TR/';
import vi from './vi/';
import zh from './zh/';

export default {
  ...ar,
  ...de,
  ...en_US,
  ...es,
  ...fr,
  ...ja_JP,
  ...nl,
  ...pt_BR,
  ...ru,
  ...test_LNG,
  ...tr_TR,
  ...vi,
  ...zh,
};
